import React from 'react'
import Navegador from '../components/Navegador'
import Galeria from '../components/Galeria'
import '../styles/Tienda.css'
import ruta from '../routes/api-routes'
import axios from 'axios'

class Tienda extends React.Component {
    state = {
        data: [],
        buscar: "",
        error: ""
    }
  
    // This make a request to the API endpoint
    async componentDidMount(){
        await this.fetchCarros()        
    }

    // This is the request's body function
    fetchCarros = async () => {
        try {
            // This just get data from the API
            // Routes were configured in the "ruta" file
            const res = await axios.get(ruta.carros)
            let data = await res.data
            this.setState({
                data,
                error: ""
            })
        } catch (error) {
            this.setState({
                error: "No se ha encontrado información de la API."
            })
        }
    }

    // Handle change works when a key is pressed on the form
    handleChange = e => {        
        this.setState({
            [e.target.name]: e.target.value
        })
    }
    
    // When the user press a key on the search input
    // The state change and create a filter to show different data
    handleBuscar = e => {
        e.preventDefault()
        console.log(this.state.buscar)
    }
    
    render(){

        // This is a filter which changes the list of cars on the screen
        let filtro = this.state.data.filter(
            (carro) => {
                return carro.brand.toLowerCase().indexOf(this.state.buscar.toLowerCase()) !== -1
            }
        )

        return(
            <React.Fragment>
                <Navegador/>
                <form className="form-inline tiendaForm">
                    <input className="form-control mr-sm-2 m-4" type="search" placeholder="Escribe la marca" aria-label="Search"
                    onChange={this.handleChange}
                    name="buscar"
                    value={this.state.buscar}/>
                    <button className="btn btn-outline-danger my-2 tiendaBotonBuscar" type="submit" onClick={this.handleBuscar}>Buscar</button>
                </form>
                <h5 className="text-center mt-3">{this.state.error}</h5>
                <Galeria
                    tipo = "card"
                    carros = {filtro}
                />
            </React.Fragment>
        )
    }
}

export default Tienda